import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import './input.scss';
function URInputwithLabel(props: any) {
  let { className, label, name, disabled, value, readonly, placeHolder, maxLength, onChange,id, ...restProps } = props;
  
  return (
    <div className="inputBox">
      <label>{label}</label>
      <Input onChange={onChange} value={value} {...restProps} placeholder={placeHolder} className={className} id={id}/>
    </div>
  );
}

export {
  URInputwithLabel
};

URInputwithLabel.defaultProps = {
  className: "",
  disabled: false
};

URInputwithLabel.propTypes = {
  className: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.any,
  placeHolder: PropTypes.any,
  label: PropTypes.any,
  value: PropTypes.any,
  name: PropTypes.any,
  maxLength: PropTypes.any,
  readonly: PropTypes.string,
  id : PropTypes.string
};
